import styled, { css } from 'styled-components';

import {
  getThemeColor,
  getThemeColorWithError,
  getThemePath,
  getThemeTransition,
  hexToRgba,
} from '@utils/styled';

export const ModeToggleWrapper = styled.div`
  position: relative;
  z-index: 5;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
`;

export const Label = styled.label`
  display: inline-flex;
  flex-direction: column;
  max-width: 100%;
  user-select: none;
`;

export const Switch = styled.div`
  position: relative;
  opacity: ${({ disabled }) => (disabled ? 0.3 : 1)};
  display: flex;
  width: auto;
  height: 3.4rem;
  border-radius: ${({ theme }) => theme.borderRadiuses.pill}rem;
  background: ${getThemeColor('bluegrey.95')};
  pointer-events: ${({ disabled }) => (disabled ? 'none' : 'auto')};
  cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};
  ${({ blurred }) =>
    blurred &&
    css`
      backdrop-filter: blur(10px);
      background-color: ${hexToRgba('#f0f1f2', 0.5)};
    `}
`;

export const OptionLabel = styled.span`
  position: relative;
  z-index: 2;
  overflow: hidden;
  display: inline-block;
  flex-grow: 1;
  height: 3.4rem;
  padding: 0 1.4rem;
  color: ${({ blurred }) =>
    !blurred
      ? getThemeColorWithError('bluegrey.60', 'bluegrey.15', 'isActive')
      : hexToRgba('#202226', 0.5)};
  ${({ theme }) => theme.getFluidFont('body4')};
  line-height: 3.4rem;
  text-overflow: ellipsis;
  white-space: nowrap;
  transition: ${getThemeTransition('color')};
`;

const getSliderSizeAndPosition = ({ widths, switched, withInnerSlider }) => {
  return withInnerSlider
    ? css`
        top: 2px;
        left: ${switched ? widths[0] - 2 : 2}px;
        width: ${switched ? widths[1] : widths[0]}px;
        height: 3rem;
      `
    : css`
        left: ${switched ? widths[0] : 0}px;
        width: ${switched ? widths[1] : widths[0]}px;
        height: 3.4rem;
        box-shadow: ${getThemePath('shadows.0')};
      `;
};

export const Slider = styled.span`
  position: absolute;
  border-radius: ${({ theme }) => theme.borderRadiuses.pill}rem;
  background-color: ${getThemeColor('grey.100')};
  color: transparent;
  white-space: nowrap;
  transition: ${getThemeTransition('left')};
  ${getSliderSizeAndPosition}
`;
